import { LazyMotion, domAnimation, m } from 'framer-motion';

/**
 * Slim framer-motion entry for the marketing tree. `m` components carry no
 * animation code of their own — features arrive via <LazyMotion domAnimation>
 * (animations, variants, exit, hover/tap gestures; no layout/drag, which the
 * marketing pages don't use). Importing from here instead of 'framer-motion'
 * keeps the full `motion` feature bundle (~85 KB min) out of the entry chunk.
 *
 * App-shell pages (onboarding, agents-list) still import 'framer-motion'
 * directly — they live in lazy route chunks where the full bundle is isolated,
 * and they render outside this provider.
 */
export { m as motion };
export {
  AnimatePresence,
  MotionConfig,
  animate,
  useInView,
  useReducedMotion,
} from 'framer-motion';

/**
 * Shared motion tokens — one entrance vocabulary for the whole marketing
 * site instead of per-file copies. Pair with `viewport={viewportOnce}` for
 * scroll-triggered reveals.
 */
export const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 },
} as const;

export const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.08 } },
} as const;

export const viewportOnce = { once: true, margin: '-80px' } as const;

export function MotionProvider({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element {
  return (
    <LazyMotion features={domAnimation} strict>
      {children}
    </LazyMotion>
  );
}
